import { render, staticRenderFns } from "./SupplyPointNotesComponent.vue?vue&type=template&id=6ce3886c"
import script from "./SupplyPointNotesComponent.vue?vue&type=script&lang=js"
export * from "./SupplyPointNotesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports